/**
 * @generated SignedSource<<61c524636ae7c6db90724329336f57a9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription$data = {
  readonly description: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription">;
  readonly " $fragmentType": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription";
};
export type async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription$key = {
  readonly " $data"?: async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription$data;
  readonly " $fragmentSpreads": FragmentRefs<"async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "async_softwareReleasesVersionSummaryDescription_AsyncEditableVersionSummaryDescription",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "description"
    },
    {
      "kind": "FragmentSpread",
      "name": "editableVersionSummaryDescription_softwareReleasesVersionSummaryDescription"
    }
  ],
  "type": "JiraVersion"
};

(node as any).hash = "2a90bb83f1ef52be3fdf77ad96c33404";

export default node;
